import React from 'react'

const About = () => {
    return (
        <div className='about'>
            <div className='flex'>
                <div>
                <h3>About Us</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Animi delectus cupiditate fugit pariatur, accusamus officia at esse repellendus voluptatum nisi architecto repudiandae non id tempora, doloribus nostrum aliquid laboriosam velit molestias expedita temporibus sunt? Impedit.</p>
                </div>
                
            </div>
        </div>
    )
}

export default About
